$(function () {
    /**
     * Creates a collapsible tree structure
     *
     * @param {jQuery} $object
     */
    function tree($object) {
        const openedClass = FontAwesome.prefix('solid', 'chevron-right');
        const closedClass = FontAwesome.prefix('solid', 'chevron-down');

        $object.each(function () {
            var tree = $(this);

            tree.find('li:has(ul)').each(function () {
                var branch    = $(this);
                var indicator = $('<i class="indicator ' + closedClass + '"></i>');

                branch.addClass('branch').prepend(indicator);
                branch.children('ul').hide();
            });

            tree.find('.indicator').on('click', function (e) {
                e.stopPropagation();
                var branch = $(this).closest('li');
                var icon   = branch.children('.indicator:first');

                icon.toggleClass(openedClass + ' ' + closedClass);
                branch.children('ul').toggle();
            });

            tree.find('.branch > a').on('click', function (e) {
                e.preventDefault();
                $(this).siblings('.indicator').trigger('click');
            });
        });
        $object.show();
        $('.loading-spinner').hide();
    }

    /**
     * Hide any buttons and show the loading spinner
     *
     * @return {void}
     */
    function hideButtonsShowLoadingSpinner() {
        // Remove any icons and buttons from previous permissions
        $('i.check, a.delete-permission-button, a.add-permission-button').remove();
        $('.loading-spinner').show();
    }

    /**
     * Load user permissions via AJAX request.
     *
     * @param  {number} userId
     * @return {void}
     */
    function loadUserPermissions(userId) {
        $.ajax({
            url: 'pages/ajax_getUserPermissions',
            type: 'POST',
            data: {
                user_id: userId,
                myvle_csrf_test_name: csrfToken,
            },
            dataType: 'json',
            success: function (response) {
                if (response.error) {
                    console.error(response.error);
                } else {
                    $('.loading-spinner').hide();
                    applyPermissionIcons(response.data);
                }
            },
            error: function (xhr) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    alert('Error: ' + response.message);
                } catch {
                    alert('An unexpected error occurred.');
                }
            },
        });
    }

    // Define constants for permission icons
    const ICON_TYPES = {
        DIRECT: {
            icon: 'check-circle',
            iconClass: 'check-direct',
            iconType: 'solid',
        },
        INHERITED: {
            icon: 'check-circle',
            iconClass: 'check-inherited',
            iconType: 'regular',
        },
        SIGNPOST: {
            icon: 'circle-chevron-down',
            iconClass: 'check-signpost',
            iconType: 'solid',
        },
    };

    const canManagePermissions = $('#permissions-tree').length ? userRole === 'sysadmin' : false;

    /**
     * Add appropriate permission icon to a specified element
     *
     * @param  {jQuery} $element
     * @param  {Object} iconType
     * @return {void}
     */
    function addPermissionIcon($element, iconType, permissionId = null) {
        if ($element.length === 0 || $element.find('.check').length > 0) {
            return;
        }

        const iconHtml = ` <i class="check ${iconType.iconClass} ${FontAwesome.prefix(iconType.iconType, iconType.icon)}"></i>`;
        $element.append(iconHtml);

        if (canManagePermissions === true && iconType === ICON_TYPES.DIRECT) {
            addDeletePermissionButton($element, permissionId);
        }
    }

    /**
     * Add a delete permission button next to the specified element.
     *
     * @param {jQuery} $element
     * @param {number|null} permissionId
     */
    function addDeletePermissionButton($element, permissionId = null) {
        if (permissionId === null) {
            return;
        }

        let $listElement = $element.is('a') ? $element.parent() : $element;
        let idAttribute  = $listElement.attr('id');
        let itemType     = idAttribute.split('-', 1)[0];

        let itemBreadcrumb = $listElement.data('breadcrumb');
        let $targetElement = $element.is('li') ? $element.children('a').first() : $element;

        const deleteButtonHtml = `<a href="#delete-permission-modal" class="delete-permission-button" aria-label="Delete permission" data-toggle="modal" data-permission-id="${permissionId}" data-type="${itemType}" data-breadcrumb="${itemBreadcrumb}">
            <i class="fa-xs ${FontAwesome.prefix('solid', 'trash')}"></i>
        </a>`;

        $targetElement.length ? $targetElement.after(deleteButtonHtml) : $element.append(deleteButtonHtml);
    }

    /**
     * Add a new permission button next to the specified element.
     *
     * @param {jQuery} $element
     */
    function addNewPermissionButton($element, itemType, itemId, itemBreadcrumb) {
        if ($element.length === 0 || $element.find('.check').length > 0) {
            return;
        }

        const addPermissionHtml = `<a href="#add-permission-modal" class="add-permission-button" aria-label="Add new permission" data-toggle="modal" data-type="${itemType}" data-id="${itemId}" data-breadcrumb="${itemBreadcrumb}">
            <i class="${FontAwesome.prefix('solid', 'plus')}"></i>
        </a>`;

        let $targetElement = $element.is('li') ? $element.children('a').first() : $element;
        $targetElement.length ? $targetElement.after(addPermissionHtml) : $element.append(addPermissionHtml);
    }

    /**
     * Apply permission icons to various pages, sections, and subsections based on user permissions
     *
     * @param  {Object} permissions
     * @return {void}
     */
    function applyPermissionIcons(permissions) {
        // Add icons for pages
        $.each(permissions.pages, function (permissionId, pageId) {
            const $pageElement = $(`#page-${pageId} > a`);
            if ($pageElement.length) {
                addPermissionIcon($pageElement, ICON_TYPES.DIRECT, permissionId);

                let $parentListItem = $pageElement.closest('li.programme-year');
                if ($parentListItem.length) {
                    let $parentAnchor = $parentListItem.find('a').first();
                    if ($parentAnchor.length) {
                        addPermissionIcon($parentAnchor, ICON_TYPES.SIGNPOST);
                    }
                }
            }
        });

        // Add icons for sections and subsections
        $.each(permissions.sections, function (permissionId, sectionId) {
            const $sectionElement = $(`#section-${sectionId}, #subsection-${sectionId}`);
            if ($sectionElement.length) {
                let $sectionAnchor = $sectionElement.find('a:not(.delete-permission-button)').first();

                if ($sectionAnchor.length) {
                    addPermissionIcon($sectionAnchor, ICON_TYPES.DIRECT, permissionId);
                } else {
                    addPermissionIcon($sectionElement, ICON_TYPES.DIRECT, permissionId);
                }

                // Add inheritance icon to subsections under sections with direct permission icons
                $sectionElement.find('ul > li').each(function () {
                    let $subsection       = $(this);
                    let $subsectionAnchor = $subsection.find('a:not(.delete-permission-button)').first();
                    let $parentSection    = $subsection.closest('li[id^="section-"]');

                    if ($parentSection.find('a .check-direct').length) {
                        if ($subsectionAnchor.length) {
                            addPermissionIcon($subsectionAnchor, ICON_TYPES.INHERITED);
                        } else {
                            addPermissionIcon($subsection, ICON_TYPES.INHERITED);
                        }
                    }
                });

                // Add signposting icon to parent elements
                let $parentListItem = $sectionElement.closest('li');
                while ($parentListItem.length) {
                    let $parentAnchor = $parentListItem.find('a:not(.delete-permission-button)').first();
                    if ($parentAnchor.length) {
                        addPermissionIcon($parentAnchor, ICON_TYPES.SIGNPOST);
                    }
                    $parentListItem = $parentListItem.parent().closest('li');
                }
            }
        });

        // Add inheritance icons inside sections within pages that have direct permission icons
        $.each(permissions.pages, function (_, pageId) {
            $(`#page-${pageId} li`).each(function () {
                let $sectionElement = $(this);
                let $programmeYear  = $sectionElement.closest('li[id^="page-"]');

                if (!$programmeYear.length || !$programmeYear.find('a .check-direct').length) {
                    return;
                }

                let $anchorElement = $sectionElement.find('a:not(.delete-permission-button)').first();
                if ($anchorElement.length) {
                    addPermissionIcon($anchorElement, ICON_TYPES.INHERITED);
                } else {
                    addPermissionIcon($sectionElement, ICON_TYPES.INHERITED);
                }
            });
        });

        // Add 'add-permission' button where no DIRECT or INHERITED icon exists
        if (canManagePermissions === true) {
            $('li[id^="page-"], li[id^="section-"], li[id^="subsection-"]').each(function () {
                let $element       = $(this);
                let itemBreadcrumb = $element.data('breadcrumb');
                let idAttribute    = $element.attr('id');

                // Extract type and id
                let parts    = idAttribute.split('-');
                let itemType = parts[0];
                let itemId   = parts[1];

                let $anchorElement = $element.find('a:not(.delete-permission-button)').first();

                if ($anchorElement.length) {
                    addNewPermissionButton($anchorElement, itemType, itemId, itemBreadcrumb);
                } else {
                    addNewPermissionButton($element, itemType, itemId, itemBreadcrumb);
                }
            });
        }
    }

    var userInView;

    /**
     * Event handler that triggers when the staff dropdown changes
     *
     * @return {void}
     */
    $('#staff_id').on('change', function () {
        const staffId = $(this).val();

        if (staffId) {
            hideButtonsShowLoadingSpinner();
            loadUserPermissions(staffId);
            const userDetails  = $('#staff_id option:selected').text();
            const userFullName = userDetails.split('(', 1)[0].trim();
            userInView = {
                id: staffId,
                name: userFullName,
            };
        }
    });

    // Script to run when 'new permission' modal is opened
    $('#add-permission-modal').on('show.bs.modal', function (e) {
        let button   = $(e.relatedTarget);
        let itemType = button.data('type');
        let itemId   = button.data('id');
        let itemName = button.data('breadcrumb');

        if (itemType === 'page' || itemType === 'section') {
            $('#inheritance-warning-add').show();
        } else {
            $('#inheritance-warning-add').hide();
        }

        $('#add-item-details').text(itemName + ' (' + itemType + ')');
        $('#add-user-details').text(userInView.name);
        $('#add-item-type').val(itemType);
        $('#add-item-id').val(itemId);
    });

    // Handle the save permission button click
    $('#save-permission').on('click', function () {
        let addType     = $('#add-item-type').val();
        let addId       = $('#add-item-id').val();
        let $saveButton = $(this);

        $saveButton.prop('disabled', true);

        $.ajax({
            url: 'pages/ajax_saveUserPermission',
            type: 'POST',
            data: {
                type: addType,
                itemId: addId,
                userId: userInView.id,
                myvle_csrf_test_name: csrfToken,
            },
            dataType: 'json',
            beforeSend: function () {
                hideButtonsShowLoadingSpinner();
            },
            success: function () {
                $('#add-permission-modal').modal('hide');
                loadUserPermissions(userInView.id);
            },
            error: function (xhr) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    alert('Error: ' + response.message);
                } catch {
                    alert('An unexpected error occurred.');
                }
                $('#add-permission-modal').modal('hide');
            },
        });

        $('#add-permission-modal').on('hidden.bs.modal', function () {
            $saveButton.prop('disabled', false);
        });
    });

    // Script to run when 'delete permission' modal is opened
    $('#delete-permission-modal').on('show.bs.modal', function (e) {
        let button       = $(e.relatedTarget);
        let itemType     = button.data('type');
        let permissionId = button.data('permission-id');
        let itemName     = button.data('breadcrumb');

        if (itemType === 'page' || itemType === 'section') {
            $('#inheritance-warning-delete').show();
        } else {
            $('#inheritance-warning-delete').hide();
        }

        $('#delete-item-details').text(itemName + ' (' + itemType + ')');
        $('#delete-user-details').text(userInView.name);
        $('#delete-item-type').val(itemType);
        $('#delete-item-id').val(permissionId);
    });

    // Handle the delete permission button click
    $('#delete-permission').on('click', function () {
        let deleteType    = $('#delete-item-type').val();
        let deleteId      = $('#delete-item-id').val();
        let $deleteButton = $(this);

        $deleteButton.prop('disabled', true);

        $.ajax({
            url: 'pages/ajax_deleteUserPermission',
            type: 'POST',
            data: {
                type: deleteType,
                permissionId: deleteId,
                myvle_csrf_test_name: csrfToken,
            },
            dataType: 'json',
            beforeSend: function () {
                hideButtonsShowLoadingSpinner();
            },
            success: function () {
                $('#delete-permission-modal').modal('hide');
                loadUserPermissions(userInView.id);
            },
            error: function (xhr) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    alert('Error: ' + response.message);
                } catch {
                    alert('An unexpected error occurred.');
                }
                $('#delete-permission-modal').modal('hide');
            },
        });

        $('#delete-permission-modal').on('hidden.bs.modal', function () {
            $deleteButton.prop('disabled', false);
        });
    });

    // Initialise the tree structure and disable drop-down placeholder
    $('#staff_id option:first').prop('disabled', true);
    tree($('.tree'));
});
